import { connect } from 'react-redux';
import Security from './Security';

const mapStateToProps = (state: any) => ({
  loggedUserId: state.session.userId,
  user: state.users.details.user.details,
  has2faEnabled: state.authSettings.user.twoFactorAuth.enabled,
  hasSamlEnabled: state.authSettings.user.saml.enabled,
  isLoading: state.users.details.user.isLoading || state.authSettings.user.isLoading,
  failed: state.users.details.user.failed || state.authSettings.user.failed,
});

export default connect(mapStateToProps, null)(Security);
